module.exports = __webpack_public_path__ + "img/kv_img_5.c3f9e258.png";